import { combineReducers } from 'redux';
import getReservationProviders from 'store/reducers/reservation-provider/get-reservation-providers';
import postReservationProvider from 'store/reducers/reservation-provider/post-reservation-provider';
import getReservationProvider from 'store/reducers/reservation-provider/get-reservation-provider';
import getReservationProviderSettings from 'store/reducers/reservation-provider/get-reservation-provider-settings';
import getReservationProviderSelectList from 'store/reducers/reservation-provider/get-reservation-provider-select-list';
import getProviderLodgingPolicy from 'store/reducers/reservation-provider/get-provider-lodging-policy';
import setDefaultReservationProvider from 'store/reducers/reservation-provider/set-default-reservation-provider';

export default combineReducers({
  getReservationProviders,
  postReservationProvider,
  getReservationProvider,
  getReservationProviderSettings,
  getReservationProviderSelectList,
  getProviderLodgingPolicy,
  setDefaultReservationProvider,
});
